<template>
	<div class="v-typeahead">
		<input
			v-model="search" class="v-typeahead__input"
			type="text"
			@blur="blured"
			@focus="focused"
			@keyup.down="next"
			@keyup.up="prev"
			@keyup.esc="clear"
			@keyup.tab="hideMenu"
			@keydown.enter="select">
		<div v-if="menu" class="v-typeahead__menu">
			<p v-if="!validatedOptions.length" class="v-typeahead__menu__empty">Nothing found</p>
			<div v-for="(dataset, datasetIndex) in validatedDatasets" v-else class="v-typeahead__menu__dataset">
				<header
					v-if="dataset.templates && dataset.templates.header" class="v-typeahead__menu__dataset__header"
					v-html="dataset.templates.header"></header>
				<p v-if="!haveValidatedOptionsForDataset(dataset)">Nothing found</p>
				<ul v-else class="v-typeahead__menu__dataset__list">
					<li
						v-for="(option, optionIndex) in validatedOptionsForDataset(dataset)"
						:class="optionClass(option)"
						class="v-typeahead__menu__dataset__list__option"
						@mousedown="(e) => select(e, option)"
						@mouseover="setCursorPosition(optionIndex)"
						v-html="option.display"/>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			search: "",
			cursorPosition: 0,
			showMenu: false,
			selection: null,
		};
	},

	props: {
		options: [],
		placeholder: "Search",
		datasets: {
			type: Array,
			default() {
				return [];
			},
		},
		prefill: {
			required: false,
			type: String,
			default() {
				return null;
			},
		},
		excluded: {
			type: Array,
			default() {
				return [];
			},
		},
		mustMatch: {
			type: Boolean,
			default() {
				return true;
			},
		},
	},

	computed: {
		suggestion() {
			return this.validatedOptions[this.cursorPosition];
		},
		menu() {
			return this.showMenu;
			return this.validatedOptions.length > 0 && this.showMenu;
		},
		validatedDatasets() {
			let self = this;

			if (!self.search.length) return [];

			return _.filter(this.datasets, function (dataset) {
				return self.validatedOptionsForDataset(dataset).length;
			});
		},
		validatedOptions() {
			let self = this;

			if (!self.search.length) return [];

			return _.flatMap(self.validatedDatasets, function (dataset) {
				return self.validatedOptionsForDataset(dataset);
			});
		},
	},

	methods: {
		setSearch(value) {
			this.clear();
			this.search = value ? value : "";
		},
		optionClass(option) {
			return {
				"v-typeahead__menu__dataset__list__option--cursor": _.findIndex(this.validatedOptions, option) === this.cursorPosition,
			};
		},
		focused(e) {
			this.$emit("focused");
		},
		blured(e) {
			this.hideMenu();
			this.$emit("blured");
		},
		next() {
			if (!this.validatedOptions.length) return;

			this.cursorPosition = this.cursorPosition + 1;

			if (this.cursorPosition > this.validatedOptions.length - 1) {
				this.cursorPosition = 0;
			}
		},
		prev() {
			if (!this.validatedOptions.length) return;

			this.cursorPosition = this.cursorPosition - 1;

			if (this.cursorPosition < 0) {
				this.cursorPosition = this.validatedOptions.length - 1;
			}
		},
		clear() {
			this.search = "";
			this.hideMenu();
			this.$emit("cleared");
		},
		hideMenu() {
			this.cursorPosition = 0;
			this.showMenu = false;
		},
		select(e, option) {
			let choice = option || this.suggestion;

			if (!this.suggestion) {
				this.$emit("autocomplete-failed", this.search, this, e);

				return;
			}

			e.preventDefault();

			this.selection = choice;
			this.search = this.selection.display;

			this.$emit("autocompleted", this.selection, e);
			this.hideMenu();
		},
		haveValidatedOptionsForDataset(dataset) {
			return Object.keys(this.validatedOptionsForDataset(dataset)).length;
		},
		validatedOptionsForDataset(dataset) {
			let validOptions = _.filter(dataset.source, function (option) {
				return this.optionOk(option);
			}.bind(this));

			if (!this.excluded.length) {
				return validOptions;
			}

			return _.filter(validOptions, function (option) {
				return _.findIndex(this.excluded, ["identify", option.identify]) < 0;
			}.bind(this));
		},
		optionOk(option) {
			return option.display.toLowerCase().startsWith(this.search.toLowerCase());
		},
		setCursorPosition(position) {
			this.cursorPosition = position;
		},
	},

	watch: {
		search() {
			this.showMenu = this.search !== "";
			this.selection = null;
			this.$emit("changed", this.search);
		},
	},

	created() {
		if (this.prefill) {
			this.search = this.prefill;
		}
	},
};
</script>
